import Models from '../../Components/Vimdt/Models/Models';
import useRowCount from '../../Utils/Vimdt/useRowCount';

function ModelsPage() {
	return <Models rowCount={useRowCount()} />;
}

export default ModelsPage;
